<template>
    <div class="card card-pdv">
        <PageHeader :title="i18nExtraPointsPerChain" />
        <div class="card-body">
            <column-chart
                :categories-series-prop="categories"
                :series-prop="series"
                :hide-legend="true"
                :busy="loading"
            />
        </div>
    </div>
</template>

<script>
import ExtraPointService from '@src/services/dashboards/widgets/ExtraPointService'

import PageHeader from '@/src/components/PageHeader.vue'
import ColumnChart from '@/src/components/charts/ColumnChart.vue'
import swalFeedback from '@src/mixins/swalFeedback.vue'
import validationMixin from '@src/mixins/validation.vue'
import { map } from 'lodash'

const i18nKey = 'DASHBOARDS'

export default {
    components: {
        PageHeader,
        ColumnChart,
    },
    mixins: [
        validationMixin,
        swalFeedback,
    ],
    props: {
        busy: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            i18nKey,
            loading: false,
            series: [],
            categories: [],
        }
    },
    validations: {},
    computed: {
        i18nExtraPointsPerChain() {
            return this.getI18n(i18nKey, 'TITLES.extra_points_per_chain')
        },
    },
    methods: {
        refresh(parameters) {
            this.loading = true
            this.series = []
            this.categories = []

            ExtraPointService.perChain(parameters)
                .then((response) => {
                    this.categories = map(response.data.data, 'chain')

                    this.series.push({
                        name: 'Total',
                        data: map(response.data.data, 'total')
                    })

                    this.loading = false
                })
                .catch((err) => {
                    this.loading = false
                    return err
                })
        },
    },
}
</script>
